import Closed from '@/components/Pages/Closed'
import { CAMPAIGNS } from '@/constants/campaigns'
import closedLayout from '@/constants/contents/greatest_hits/layout/closed.json'
import { DEFAULT_LOCALE } from '@/constants/locales'
import PAGES from '@/constants/pages'
import checkCampaign from '@/utils/check-campaign'
import { getIsSsrMobile } from '@/utils/get-is-ssr-mobile'

export default Closed

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const locale = ctx.params?.locale ?? DEFAULT_LOCALE
  const { PREFIX } = PAGES.CLIENT.UCT
  const isOpen = await checkCampaign(CAMPAIGNS.ULTIMATECOACHINGTRIP.name)
  const query = ctx.resolvedUrl.split('?')[1]

  if (isOpen) {
    return {
      redirect: {
        destination: `${PREFIX}/${locale}${query ? `?${query}` : query}`,
        permanent: false,
      },
    }
  }

  return {
    props: {
      locale,
      layout: closedLayout[locale as keyof typeof closedLayout],
      isSsrMobile: getIsSsrMobile(ctx),
    },
  }
}
